import { useCallback, useEffect, useState } from 'react';

import { ISmIncomingEvent, SM_PLUGIN_READY_MESSAGE, SMPluginWindow } from '@noc-sm-plugin';

declare let window: SMPluginWindow;

/**
 * Hook to process SalesManago events based on `noc-sm-plugin`
 */
export const useNocSmProcessor = () => {
    const [pluginInitialized, setPluginInitialized] = useState<boolean>(false);
    const [queueProcessing, setQueueProcessing] = useState<boolean>(false);
    const [eventsQueue, setEventsQueue] = useState<ISmIncomingEvent[]>([]);

    useEffect(() => {
        setPluginInitialized(typeof window?.Noc?.sm === 'object');

        const handler = (event: MessageEvent): void => {
            if(event.data === SM_PLUGIN_READY_MESSAGE && !pluginInitialized) {
                setPluginInitialized(true);
                window.removeEventListener('message', handler);
            }
        };

        if(!pluginInitialized){
            window.addEventListener('message',handler.bind(this));
        }
    }, []);


    useEffect(() => {
        if(!pluginInitialized || queueProcessing || !eventsQueue.length || !window?.Noc?.sm) {
            return;
        }

        setQueueProcessing(true);
        const event = eventsQueue[0];

        try { process(event); }
        catch (error) { console.error(error); }
        finally {
            setEventsQueue((prevEventsQueue) => prevEventsQueue.slice(1));
            setQueueProcessing(false);
        }
    }, [eventsQueue, queueProcessing, pluginInitialized]);

    const process = useCallback((event:ISmIncomingEvent) => {
        if(!pluginInitialized && !window?.Noc?.sm) {
            setEventsQueue((prevEventsQueue) => [...prevEventsQueue, event]);
            return;
        }

        window.Noc?.sm?.pushEvent(event);
    }, [pluginInitialized]);


    return { process };
};